/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const ElementCollectionBlockIcon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 16, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="ElementCollectionBlockIcon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13 9C13.5523 9 14 9.44772 14 10V13C14 13.5523 13.5523 14 13 14H9C8.44772 14 8 13.5523 8 13V10C8 9.44772 8.44772 9 9 9H13ZM9 13H13V10H9V13Z"
              fill="currentColor"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7 2C8.31121 2 9.5231 2.294 10.4248 2.79492C11.3096 3.28647 12 4.04561 12 5C12 5.73423 11.5914 6.35313 11 6.82324C10.8227 6.96417 10.6288 7.09173 10.4248 7.20508C9.5231 7.706 8.31121 8 7 8C5.68879 8 4.4769 7.706 3.5752 7.20508C3.37112 7.0917 3.17731 6.9642 3 6.82324V8C3 8.42631 3.31669 8.91778 4.06055 9.33105C4.68244 9.67655 5.53232 9.92011 6.5 9.9834V10.9854C5.38253 10.9208 4.36105 10.6416 3.5752 10.2051C3.37112 10.0917 3.17731 9.9642 3 9.82324V11C3 11.4263 3.31669 11.9178 4.06055 12.3311C4.68244 12.6766 5.53232 12.9201 6.5 12.9834V13.9854C5.38253 13.9208 4.36105 13.6416 3.5752 13.2051C2.69042 12.7135 2 11.9544 2 11V5C2 4.04561 2.69042 3.28647 3.5752 2.79492C4.4769 2.294 5.68879 2 7 2ZM7 3C5.82597 3 4.78751 3.26508 4.06055 3.66895C3.31669 4.08222 3 4.57369 3 5C3 5.42631 3.31669 5.91778 4.06055 6.33105C4.78751 6.73492 5.82597 7 7 7C8.17403 7 9.21249 6.73492 9.93945 6.33105C10.6833 5.91778 11 5.42631 11 5C11 4.57369 10.6833 4.08222 9.93945 3.66895C9.21249 3.26508 8.17403 3 7 3Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

ElementCollectionBlockIcon.tags = [
  'collection',
  'collection block',
  'list',
  'stack',
  'layout',
  'document',
  'organize',
];

ElementCollectionBlockIcon.category = 'Navigator';

ElementCollectionBlockIcon.iconSize = 16;
